import React, { useMemo } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import { monthNames, monthNamesShort } from 'utils/dateFormat';
import CurrencyFormat from 'utils/currencyFormat';
import Maybe from 'components/__new/common/Maybe';
import Spinner from 'components/__new/common/Spinner';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const PayrollChart = ({ data, loading }) => {
    const chartData = useMemo(() => data.map((payroll) => ({
        month: payroll?.schedule?.month,
        year: payroll?.schedule?.year,
        grossPayAmount: payroll?.transaction_metrics?.
        total_gross_salary,
        netPayAmount: payroll?.transaction_metrics?.
        total_net_pay,
        tax: (payroll?.transaction_metrics?.total_paye_tax + payroll?.transaction_metrics?.total_taxable_benefits_in_kind + payroll?.transaction_metrics?.total_taxable_custom_bonuses),
        deductions: payroll?.transaction_metrics?.total_deductions
    })), [data])
    
    /**
     * Only display data from January to the current month
     */
    const currentMonth = new Date().getMonth();
    const filteredChartData = chartData?.filter((_, index) => index <= currentMonth);
    const labels = monthNamesShort.slice(0, currentMonth + 1).map(el => el.toUpperCase());

    const { dashboard } = useSelector((s) => s.entities.wallet);

    const options = {
        plugins: {
            title: {
            display: true,
            },
        legend: {
            display: false,
                labels: {
                    boxWidth: 8,
                    boxHeight: 8,
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: false,
                grid: { display: false },
            },

            y: {
                stacked: false,
                ticks: {
                    display: true,
                },
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                    borderDash: [5, 5],
                    drawBorder: false
                }
            },
        },
        barPercentage: 0.7,
        categoryPercentage: 0.5
    };

    const chartDatasets = {
        labels,
        datasets: [
            {
                label: 'Gross Salary',
                data: filteredChartData?.map((item) => item?.grossPayAmount / 100),
                backgroundColor: '#00535C',
                borderRadius: 6,
                barThickness: 'flex',
            },
            {
                label: 'Taxes',
                data: filteredChartData?.map((item) => item?.tax / 100),
                backgroundColor: '#197681',
                borderRadius: 6,
                barThickness: 'flex',
            },
            {
                label: 'Net Pay',
                data: filteredChartData?.map((item) => item?.netPayAmount / 100),
                backgroundColor: '#8CD2DA',
                borderRadius: 6,
                barThickness: 'flex',
            },
            {
                label: 'Deductions',
                data: filteredChartData?.map((item) => item?.deductions / 100),
                backgroundColor: '#B4C6C8',
                borderRadius: 6,
                barThickness: 'flex',
            },
        ],
    };


    return (
        <>
            <Maybe condition={loading}>
                <Spinner />
            </Maybe>

            <Maybe condition={!loading}>
                <div className="w-full flex items-center flex-wrap lg:flex-nowrap lg:border-r" style={{ height: '350px' }}>
                    <Bar options={options} data={chartDatasets} />
                </div>
            </Maybe>
        </>
        )
}

export default PayrollChart